<!-- Label Template -->
<ng-template #labelTemplate>
  @if (props.label) {
    <label [attr.for]="id"
           [class.form-check-label]="true"
           [class.checkbox-label-before]="labelPosition === 'left'"
           [style.width]="labelPosition === 'left' ? (labelWidth || null) : null">
      {{ props.label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
</ng-template>

<!-- Checkbox Input Template -->
<ng-template #checkboxInputTemplate>
  <input [id]="id"
         type="checkbox"
         [formControl]="formControl"
         [formlyAttributes]="field"
         class="form-check-input"
         [class.is-invalid]="showError" />
</ng-template>

<!-- Description and Error Template -->
<ng-template #descriptionErrorTemplate>
  @if (description) {
    <small class="form-text text-muted d-block">{{ description }}</small>
  }

  @if (showError) {
    <div class="invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
</ng-template>

<!-- Main Layout -->
<div class="mb-3">
  @if (labelPosition === 'left') {
    <div class="checkbox-inline-wrapper">
      <div class="checkbox-inline-container">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
        <div class="checkbox-inline-field">
          <div class="form-check">
            <ng-container *ngTemplateOutlet="checkboxInputTemplate"></ng-container>
          </div>
        </div>
      </div>
      <div class="checkbox-description-row"
           [style.padding-left]="labelWidth ? 'calc(' + labelWidth + ' + 1rem)' : '0'">
        <ng-container *ngTemplateOutlet="descriptionErrorTemplate"></ng-container>
      </div>
    </div>
  } @else {
    <div class="form-check">
      <ng-container *ngTemplateOutlet="checkboxInputTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="descriptionErrorTemplate"></ng-container>
    </div>
  }
</div>